import { render, staticRenderFns } from "./KanbanFormSelector.vue?vue&type=template&id=d74623ac&scoped=true"
import script from "./KanbanFormSelector.vue?vue&type=script&lang=js"
export * from "./KanbanFormSelector.vue?vue&type=script&lang=js"
import style0 from "./KanbanFormSelector.vue?vue&type=style&index=0&id=d74623ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74623ac",
  null
  
)

export default component.exports